import { useEffect } from "react";
import { X } from "lucide-react";

export default function ImageLightbox({ src, alt, onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 sm:p-10 reveal"
      onClick={onClose}
      data-testid="image-lightbox"
    >
      <button
        onClick={onClose}
        data-testid="lightbox-close"
        className="absolute top-4 right-4 h-11 w-11 rounded-full bg-white/10 hover:bg-white/20 text-white grid place-items-center transition-colors"
        aria-label="Kapat"
      >
        <X size={20} />
      </button>
      <img
        src={src}
        alt={alt || ""}
        onClick={(e) => e.stopPropagation()}
        className="max-w-full max-h-[90vh] object-contain rounded-xl shadow-2xl"
        data-testid="lightbox-image"
      />
    </div>
  );
}
